import { FormContainer } from 'react-hook-form-mui';
import { useHistory } from 'react-router-dom';
import { contactRoutes } from '../../../routes';
import { useCreateContact } from '../../../sic-lib/api/hooks/useContact';
import { quickCreateContactDefaults } from '../../../sic-lib/defaults';
import { buildCreateContact } from '../../../sic-lib/types/Contact';
import { QuickCreateContact } from '../../../sic-lib/types/QuickCreateContact';
import { startCall } from '../../../store/dialer';
import { useAppDispatch } from '../../../store/hooks';
import { QuickCallCreateContactFormControls } from './QuickCallCreateContactFormControls';

interface Props {
    handleClose: () => void;
    txtSearch: string;
    containerRef: React.RefObject<HTMLDivElement>;
}

export function QuickCallCreateContactForm({ handleClose, txtSearch, containerRef }: Props) {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const {
        mutateAsync: createContact,
        isPending: isLoading,
        isError,
        error: createContactError,
    } = useCreateContact();

    const handleCreateAndCall = async (formValues: QuickCreateContact) => {
        const contact = await createContact(
            buildCreateContact({
                firstName: formValues.firstName,
                lastName: formValues.lastName,
                pPolicy: formValues.pPolicy,
                terms: formValues.terms,
                consent: formValues.consent,
                values: [
                    {
                        fieldId: formValues.phoneFieldId,
                        value: txtSearch,
                    },
                ],
            }),
        );

        history.push(contactRoutes.setDetails(contact.contactId));

        dispatch(
            startCall({
                phoneNumber: txtSearch,
                contactId: contact.contactId,
                firstName: contact.firstName || '',
                lastName: contact.lastName || '',
            }),
        );

        handleClose();
    };

    return (
        <FormContainer<QuickCreateContact>
            defaultValues={{ ...quickCreateContactDefaults, phoneNumber: txtSearch }}
            mode="all"
            onSuccess={handleCreateAndCall}
        >
            <QuickCallCreateContactFormControls
                isLoading={isLoading}
                isError={isError}
                error={createContactError}
                containerRef={containerRef}
            />
        </FormContainer>
    );
}
